import { VUE_APP_BASEURL } from "../../utils/api";
import axios from "axios";
import store from "../../store";
// import sigmabanner1 from "../../assets/sigmabanner1.jpg"
const state = {
    locations: [],
    banners: [{ "image": '' }],
    // banners: [{ "image": sigmabanner1 }],
    currentLocation: localStorage.getItem("currentLocation") || 1,
    location: [],
}
const getters = {
    locationList: state => state.locations,
    UserLocation: state => state.currentLocation,
    bannerList: state => state.banners,
    locationDetails: state => state.location,
}

const actions = {
    async getLocations({ commit }) {
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "location"
        })
            .then(function (response) {
                //console.log(response.data);
                if (response.data.status == 1) {
                    //console.log(response.data.response.location);
                    commit("listLocations", response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    async getBanners({ commit }) {
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "banner/" + store.getters.UserLocation
        })
            .then(function (response) {
                // console.log(response);
                if (response.data.status == 1) {
                    //console.log(response.data.response.location);
                    commit("lisBanners", response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    async getlocationDetails({ commit }) {

        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "location/" + store.getters.UserLocation
        })
            .then(function (response) {
                // console.log(response.data);
                if (response.data.status == 1) {
                    //console.log(response.data.response.location);
                    commit("updateLocationDetails", response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
}
const mutations = {
    listLocations: (state, resp) => {
        state.locations = resp.response.location;
    },
    lisBanners: (state, resp) => {
        state.banners = resp.response.banner;
    },
    updateLocationDetails: (state, resp) => {
        state.location = resp.response.location;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
};